import type { FNode, FNodeChild } from './types'

/**
 * f() - Create FNodes without JSX
 */
export function f(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- f() is a JSX factory accepting any component function or HTML tag name
    type: string | ((...args: any[]) => unknown),
    props?: Record<string, unknown>,
    ...children: FNodeChild[]
): FNode {
    return {
        type,
        props: props || {},
        children,
        key: props?.key
    }
}
